import React from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";

import * as ROUTE from "../../constant/routes";

import { getCarRequestInfo, responseCarRequest, getRejectTripReasonsOwner } from "../../model/car";
import { mapSdk } from "../../model/base";

import { commonErr } from "../common/errors";
import { LoadingPage } from "../common/loading";
import { stypes, formatPrice, renderNumberGreaterThan100 } from "../common/common";
import { initMap } from "../common/wdfunction";

import { CustomTextarea } from "../components/input";

import Insurance from "../car/components/insurance";
import PriceSummary from "../car/components/pricesummary";
import CancelPolicy from "../car/components/cancelpolicy";
import { Papers } from "../car/components/infocar";

import { IcClockL, IcStarRating, IcTotalTrip, IcStartLocGreen, IcEndLocGreen, IcAddressType } from "../common/svg";

import avatar_default from "../../static/images/avatar_default.png";
import car_photo from "../../static/images/upload/car_1.png";

class CarMapLocation extends React.Component {
	componentDidMount() {
		if (this.props.location) {
			setTimeout(() => {
				this.initMap(this.refs, this.props.location.lat, this.props.location.lon);
			}, 100);
		}
	}

	initMap = (refs, lat, lng) => {
		if (mapSdk != 0) {
			setTimeout(() => {
				initMap(true, this.refs, [{ lat: lat, lng: lng }]);
			}, 1000);
			return;
		}
		// const map = new window.google.maps.Map(refs.map, {
		//     center: {
		//         lat: lat,
		//         lng: lng
		//     },
		//     zoom: 14,
		//     mapTypeControl: false,
		//     scrollwheel: false,
		//     clickableIcons: false,
		//     streetViewControl: false,
		//     zoomControl: true,
		//     zoomControlOptions: {
		//         position: window.google.maps.ControlPosition.RIGHT_BOTTOM
		//     }
		// })

		// this.marker = new window.google.maps.Marker({
		//     map: map,
		//     position: new window.google.maps.LatLng(this.props.location.lat, this.props.location.lon)
		// });
	};

	render() {
		return <div ref="map" id="fix-map" className="wrap-map"></div>;
	}
}

export default class BookingRequestBox extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			step: 1,
			isAccept: false,
			respMessage: "",
			// directionsService: null,
			// directionsRenderer: null,
			// markerArr: [],
		};
	}

	componentDidMount() {
		this.setState({
			err: commonErr.LOADING,
		});

		//get request detail
		getCarRequestInfo(this.props.id).then((resp) => {
			let detail = resp.data.data;
			this.stype = detail.carRequest.serviceType;
			this.isSD = this.stype === stypes.SD;
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				detail,
			});

			// let { routes } = detail.carRequest.wdRouting
			// let locationArray = []
			// for (let index = 0; index < routes.length; index++) {
			//     locationArray.push({ lat: routes[index].lat, lng: routes[index].lon })
			// }
			// if (detail.carRequest.serviceType === 2) {
			//     setTimeout(() => {
			//         this.initMap(this.refs, locationArray);
			//     }, 100)
			// }
		});
	}

	onAcceptBtnClick = () => {
		this.setState({
			step: 2,
			isAccept: true,
			cancelReason: null,
		});
	};

	onRejectBtnClick = () => {
		this.setState({
			err: commonErr.LOADING,
		});
		getRejectTripReasonsOwner().then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				cancelReasons: resp.data.data.reasons,

				step: 2,
				isAccept: false,
				cancelReason: "r0",
			});
		});
	};

	onBackBtnClick = () => {
		this.setState({
			step: 1,
		});
	};

	onRespBtnClick = () => {
		this.setState({
			err: commonErr.LOADING,
		});

		//send response
		responseCarRequest(this.props.id, this.state.isAccept, this.state.respMessage, this.state.cancelReason).then(
			(resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					step: 3,
				});
			}
		);
	};

	onRespMessageChange = (event) => {
		this.setState({
			respMessage: event.target.value,
		});
	};

	onRetryBtnClick = () => {
		if (this.state.step === 1) {
			this.setState({
				err: commonErr.LOADING,
			});

			//get request detail
			this.setState({
				err: commonErr.SUCCESS,
			});
		} else if (this.state.step === 3) {
			this.setState({
				err: commonErr.LOADING,
			});

			//send response
			responseCarRequest(this.props.id, this.state.isAccept, this.state.respMessage, this.state.cancelReason).then(
				(resp) => {
					this.setState({
						err: resp.data.error,
					});
				}
			);
		}
	};

	onReasonChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	onCloseBtnClick = () => {
		this.props.hide();
	};

	isValidCancelTrip = () => {
		if (this.state.isAccept) {
			return true;
		}
		if (!this.state.cancelReason || this.state.cancelReason === "" || this.state.cancelReason === "0") {
			return false;
		}
		if (this.state.cancelReason === "r0" && (!this.state.respMessage || this.state.respMessage === "")) {
			return false;
		}
		return true;
	};

	buildTripStatusBar = (request) => {
		const { countdown } = this.state;

		switch (request.status) {
			case 1:
				return (
					<>
						<div className="step-by-step">
							<div className="step-by-step__item disable">
								<h5 className="number-step">1</h5>
								<h6 className="title-step">Chờ duyệt</h6>
							</div>
							<div className="step-by-step__item disable">
								<h5 className="number-step">2</h5>
								<h6 className="title-step">Chờ thông tin đơn hàng</h6>
							</div>
						</div>
						<div className="booking-status warning">
							<div className="wrap-svg">
								<IcClockL />
							</div>
							<div className="booking-info">
								<div className="title fontWeight-6 font-12">{request.statusT}</div>
							</div>
						</div>
					</>
				);
			case 2:
				return (
					<>
						<div className="step-by-step">
							<div className="step-by-step__item active">
								<h5 className="number-step">1</h5>
								<h6 className="title-step">Chờ duyệt</h6>
							</div>
							<div className="step-by-step__item disable">
								<h5 className="number-step">2</h5>
								<h6 className="title-step">Chờ thông tin đơn hàng</h6>
							</div>
						</div>
						<div className="booking-status">
							<div className="wrap-svg">
								<IcClockL />
							</div>
							<div className="booking-info">
								<div className="title fontWeight-6 font-12">{request.statusT}</div>
							</div>
						</div>
					</>
				);
			case 3:
				return (
					<>
						{/* <div className="step-by-step">
							<div className="step-by-step__item error">
								<h5 className="number-step">x</h5>
								<h6 className="title-step">Từ chối</h6>
							</div>
							<div className="step-by-step__item disable">
								<h5 className="number-step">x</h5>
								<h6 className="title-step">Chờ thông tin đơn hàng</h6>
							</div>
						</div> */}
						<div className="booking-status error">
							<div className="wrap-svg">
								<IcClockL />
							</div>
							<div className="booking-info">
								<div className="title fontWeight-6 font-12">{request.statusT}</div>
							</div>
						</div>
					</>
				);

			case 4:
				return (
					<>
						{/* <div className="step-by-step">
							<div className="step-by-step__item error step-full">
								<h5 className="number-step">x</h5>
								<h6 className="title-step">Đã bị từ chối bởi hệ thống</h6>
							</div>
						</div> */}
						<div className="booking-status error">
							<div className="wrap-svg">
								<IcClockL />
							</div>
							<div className="booking-info">
								<div className="title fontWeight-6 font-12">{request.statusT}</div>
							</div>
						</div>
					</>
				);
			case 5:
				return (
					<>
						<div className="step-by-step">
							<div className="step-by-step__item active">
								<h5 className="number-step">1</h5>
								<h6 className="title-step">Chờ duyệt</h6>
							</div>
							<div className="step-by-step__item active">
								<h5 className="number-step">2</h5>
								<h6 className="title-step">Tạo chuyến thành công</h6>
							</div>
						</div>
						<div className="booking-status">
							<div className="wrap-svg">
								<IcClockL />
							</div>
							<div className="booking-info">
								<div className="title fontWeight-6 font-12">{request.statusT}</div>
							</div>
						</div>
					</>
				);
			case 6:
				<>
					<div className="step-by-step">
						<div className="step-by-step__item active">
							<h5 className="number-step">1</h5>
							<h6 className="title-step">Chờ duyệt</h6>
						</div>
						<div className="step-by-step__item error">
							<h5 className="number-step">x</h5>
							<h6 className="title-step">Chờ thông tin đơn hàng</h6>
						</div>
					</div>
					<div className="booking-status error">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<div className="title fontWeight-6 font-12">{request.statusT}</div>
						</div>
					</div>
				</>;

			default:
				return null;
		}
	};

	render() {
		var content;
		const { err, errMsg, step, isAccept, cancelReasons, respMessage } = this.state;

		if (err === commonErr.INNIT || err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (step === 3) {
			if (err >= commonErr.SUCCESS) {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">{isAccept ? "Bạn đã đồng ý yêu cầu đặt xe." : "Bạn đã từ chối yêu cầu đặt xe."}</p>

						<div className="wrap-btn has-2-btn">
							<a className="btn btn-primary btn--m" href={ROUTE.MY_CARS}>
								Quản lý xe{" "}
							</a>
							<a className="btn btn-link" onClick={this.onCloseBtnClick}>
								Hoàn tất{" "}
							</a>
						</div>
					</div>
				);
			} else {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">{errMsg}</p>

						<div className="wrap-btn has-2-btn">
							<a className="btn btn-primary btn--m" onClick={this.onRetryBtnClick}>
								Thử lại{" "}
							</a>
							<a className="btn btn-link" onClick={this.onCloseBtnClick}>
								Hủy bỏ{" "}
							</a>
						</div>
					</div>
				);
			}
		} else if (step === 2) {
			content = (
				<div className="modal-confirm-body traveler-cancel-3-body">
					{!isAccept && (
						<div className="line-form">
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p className="font-14">Vui lòng chọn lí do từ chối</p>
									</div>
								</div>
								<div className="custom-select">
									<select name="cancelReason" onChange={this.onReasonChange}>
										<option value disabled selected hidden>
											Chọn lí do
										</option>
										{cancelReasons &&
											cancelReasons.map((reason, i) => (
												<option key={i} value={reason.reason}>
													{reason.desc}
												</option>
											))}
									</select>
								</div>
							</div>
						</div>
					)}
					<CustomTextarea
						name={"ip_message"}
						placeholder={"Vui lòng nhập lí do hoặc lời nhắn"}
						value={respMessage}
						onChange={this.onRespMessageChange}
					/>

					<div className="wrap-btn has-2-btn">
						<a
							className={`btn btn-primary btn--m ${this.isValidCancelTrip() ? "" : "disabled"}`}
							onClick={this.onRespBtnClick}>
							Gửi trả lời
						</a>
						<a className="btn btn-link" onClick={this.onBackBtnClick}>
							Quay lại{" "}
						</a>
					</div>
				</div>
			);
		} else {
			if (err < commonErr.SUCCESS) {
				content = (
					<div className="confirm-booking admin-booking">
						<p className="font-18">Không tìm thấy thông tin</p>

						<div className="wrap-btn has-2-btn">
							<a className="btn btn-primary btn--m" onClick={this.onRetryBtnClick}>
								Thử lại{" "}
							</a>
							<a className="btn btn-secondary btn--m" onClick={this.onCloseBtnClick}>
								Hủy bỏ{" "}
							</a>
						</div>
					</div>
				);
			} else {
				const { detail } = this.state;
				const { car, carRequest, traveler, travelerPapers } = detail;
				const priceSummary = this.isSD ? car.priceSummary : car.wdFull ? car.wdFull.priceSummary : {};

				content = (
					<div className="confirm-booking admin-booking">
						{this.buildTripStatusBar(carRequest)}

						<div className="car-info">
							<div className="car-img">
								<img loading="lazy" src={car.photos ? car.photos[0].thumbUrl : car_photo} />
							</div>
							<div className="car-desc">
								<h5 className="name">{car.name}</h5>
								<p>Biển số xe: {car.licensePlate}</p>
							</div>
						</div>

						{/* <Insurance activeIns={activeIns} insSupport={car.insSupport} openDetailIns={this.openDetailIns}/>  */}
						<div className="line-page" />

						<div className="delivery-car">
							<div className="delivery-car__item">
								<p className="title">Nhận xe</p>
								<h6 className="value">{moment(carRequest.tripDateFrom).format("dddd, HH:mm, DD/MM/YYYY - HH:mm")}</h6>
							</div>
							<div className="line-delivery"> </div>
							<div className="delivery-car__item">
								<p className="title">Trả xe</p>
								<h6 className="value">{moment(carRequest.tripDateTo).format("dddd, HH:mm, DD/MM/YYYY - HH:mm")}</h6>
							</div>
						</div>
						<div className="line-page" />

						{traveler && (
							<>
								<div className="profile">
									<a href={`/profile/${traveler.uid}`}>
										<div className="avatar avatar--m">
											<img
												loading="lazy"
												src={traveler.avatar ? traveler.avatar.thumbUrl : avatar_default}
												alt={traveler.name}
											/>
										</div>
									</a>
									<div className="profile-desc">
										<p>Khách thuê xe</p>
										<a href={`/profile/${traveler.uid}`}>
											<h6 className="name">{traveler.name}</h6>
										</a>
										<div className="desc-info">
											{traveler.traveler.totalTrips > 0 ? (
												<>
													<div className="wrap-svg">
														<IcStarRating />
													</div>
													<span className="info">{traveler.traveler.rating.avg.toFixed(1)}</span>
													<span className="dot">•</span>
													<div className="wrap-svg">
														<IcTotalTrip />
													</div>
													<span className="info">{renderNumberGreaterThan100(car.totalTrips)} chuyến</span>
												</>
											) : (
												<>
													<span className="info">Chưa có chuyến</span>
												</>
											)}
										</div>
										{/* <div className="note"> 
                                        <p>Xem giấy tờ khách thuê</p>
                                        </div> */}
									</div>
								</div>
								<div className="message">
									<div className="message-wrapper">
										<p className="title">Lời nhắn đến chủ xe</p>
									</div>
									<p className="font-18 fontWeight-5">
										{carRequest.msgFromAdmin != "" ? carRequest.msgFromAdmin : "Không có lời nhắn đến chủ xe"}
									</p>
								</div>
							</>
						)}

						<div className="line-page" />

						{this.isSD ? (
							<>
								<div className="delivery-car">
									<div className="delivery-car__item">
										<p className="title">Địa chỉ giao nhận xe </p>
										{carRequest.useCarLocation ? (
											<h6 className="value">{car.locationAddrS} </h6>
										) : (
											<h6 className="value">{carRequest.dAddr} </h6>
										)}
									</div>
								</div>
								<div className="line-page"> </div>
								<div className="delivery-car">
									<div className="delivery-car__item">
										<p className="title">Giới hạn số KM</p>
										{car.limitEnable === 1 && (
											<h6 className="value">
												{car.limitKM} km/ngày{" "}
												<span className="note">(Phí {formatPrice(car.limitPrice)} mỗi KM vượt giới hạn)</span>
											</h6>
										)}
										{car.limitEnable !== 1 && <h6 className="value"> Không giới hạn số km.</h6>}
									</div>
								</div>
								{carRequest.dLoc && !carRequest.useCarLocation ? (
									<CarMapLocation location={carRequest.dLoc} />
								) : (
									<CarMapLocation location={{ lat: car.location.lat, lon: car.location.lon }} />
								)}
							</>
						) : (
							<>
								<div className="delivery-car-wd">
									<p className="route">Lộ trình</p>
									{carRequest.wdRouting &&
										carRequest.wdRouting.routes.map((address, index) => (
											<div className="address-route">
												<div className="wrap-svg">{index === 0 ? <IcStartLocGreen /> : <IcEndLocGreen />}</div>
												<h6>{address.addr}</h6>
											</div>
										))}
								</div>

								<div id="map-wd" className="wrap-map" />
							</>
						)}
						<div className="line-page" />

						<PriceSummary priceSummary={priceSummary} isSD={this.isSD} car={true} trip={false} />

						<div className="line-page" />

						{this.isSD && (
							<>
								<Papers info={travelerPapers} trip={true} />

								<div className="line-page" />
							</>
						)}

						<div className="desc-car">
							<CancelPolicy />
						</div>

						{carRequest.status <= 1 && (
							<div className="wrap-btn has-2-btn">
								<a className="btn btn--m btn-primary" onClick={this.onAcceptBtnClick}>
									Đồng ý
								</a>
								<a className="btn btn--m btn-secondary" onClick={this.onRejectBtnClick}>
									Từ chối
								</a>
							</div>
						)}
					</div>
				);
			}
		}

		return (
			<Modal
				show={this.props.isShow}
				onHide={this.props.hide}
				dialogClassName={`modal-dialog ${
					step === 2 || step === 3 ? "modal-s modal-confirm" : "modal-l modal-confirm-booking"
				}`}>
				<Modal.Header closeButton={true} closeLabel={""}>
					{step === 2 || step === 3 ? <h5>Yêu cầu thuê xe từ Admin</h5> : <h5>Yêu cầu thuê xe từ Admin</h5>}
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}

{
	/* <div className="confirm-booking admin-booking"> 
   
   
  
   
  
    <div className="booking-status">
      <div className="wrap-svg">
        <svg width={45} height={44} viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.5788 38.9584C30.9017 38.9584 37.6488 32.2113 37.6488 23.8884C37.6488 15.5654 30.9017 8.81836 22.5788 8.81836C14.2559 8.81836 7.50879 15.5654 7.50879 23.8884C7.50879 32.2113 14.2559 38.9584 22.5788 38.9584Z" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22.5791 5.04102V8.81768" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9.25 10.5586L11.2666 12.5753" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M35.9072 10.5586L33.8906 12.5753" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22.5788 25.7767C23.6217 25.7767 24.4671 24.9312 24.4671 23.8883C24.4671 22.8454 23.6217 22 22.5788 22C21.5359 22 20.6904 22.8454 20.6904 23.8883C20.6904 24.9312 21.5359 25.7767 22.5788 25.7767Z" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22.5791 23.8874L27.2908 19.1758" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20.6904 5.04102H24.4671" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className="booking-info">
        <div className="title fontWeight-6 font-12">Bạn đã đồng ý yêu cầu thuê xe</div><span className="countdown fontWeight-6">Hệ thống sẽ gửi thông tin đến khách thuê và phản hồi kết quả đến bạn trong thời gian sớm nhất. Xin cảm ơn</span>
      </div>
    </div>
    <div className="booking-status error">
      <div className="wrap-svg">
        <svg width={45} height={44} viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.5788 38.9584C30.9017 38.9584 37.6488 32.2113 37.6488 23.8884C37.6488 15.5654 30.9017 8.81836 22.5788 8.81836C14.2559 8.81836 7.50879 15.5654 7.50879 23.8884C7.50879 32.2113 14.2559 38.9584 22.5788 38.9584Z" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22.5791 5.04102V8.81768" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9.25 10.5586L11.2666 12.5753" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M35.9072 10.5586L33.8906 12.5753" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22.5788 25.7767C23.6217 25.7767 24.4671 24.9312 24.4671 23.8883C24.4671 22.8454 23.6217 22 22.5788 22C21.5359 22 20.6904 22.8454 20.6904 23.8883C20.6904 24.9312 21.5359 25.7767 22.5788 25.7767Z" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M22.5791 23.8874L27.2908 19.1758" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20.6904 5.04102H24.4671" stroke="black" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className="booking-info"><span className="countdown fontWeight-6">Bạn đã từ chối yêu cầu thuê xe</span>
        <div className="title fontWeight-6 font-12">Xin cảm ơn bạn đã phản hồi</div>
      </div>
    </div>
 
    <div className="insurance">
      <div className="wrap-svg"><svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M16.667 0C15.287 0 12.981 0.53 10.811 1.12C8.591 1.72 6.353 2.43 5.037 2.86C4.48679 3.0417 3.99898 3.37493 3.62964 3.8214C3.26029 4.26787 3.02438 4.80948 2.949 5.384C1.757 14.338 4.523 20.974 7.879 25.364C9.30217 27.2419 10.9991 28.8957 12.913 30.27C13.685 30.816 14.401 31.234 15.009 31.52C15.569 31.784 16.171 32 16.667 32C17.163 32 17.763 31.784 18.325 31.52C19.058 31.1637 19.7592 30.7456 20.421 30.27C22.335 28.8957 24.0319 27.242 25.455 25.364C28.811 20.974 31.577 14.338 30.385 5.384C30.3098 4.8092 30.0739 4.26728 29.7046 3.82047C29.3352 3.37365 28.8474 3.04006 28.297 2.858C26.3866 2.23163 24.4614 1.65146 22.523 1.118C20.353 0.532 18.047 0 16.667 0ZM20.959 10.292C21.1468 10.1042 21.4015 9.99874 21.667 9.99874C21.9326 9.99874 22.1872 10.1042 22.375 10.292C22.5628 10.4798 22.6683 10.7344 22.6683 11C22.6683 11.2656 22.5628 11.5202 22.375 11.708L16.375 17.708C16.2821 17.8011 16.1718 17.875 16.0503 17.9254C15.9288 17.9758 15.7985 18.0018 15.667 18.0018C15.5355 18.0018 15.4052 17.9758 15.2837 17.9254C15.1622 17.875 15.0519 17.8011 14.959 17.708L11.959 14.708C11.866 14.615 11.7923 14.5046 11.742 14.3832C11.6916 14.2617 11.6657 14.1315 11.6657 14C11.6657 13.8685 11.6916 13.7383 11.742 13.6168C11.7923 13.4954 11.866 13.385 11.959 13.292C12.052 13.199 12.1624 13.1253 12.2838 13.075C12.4053 13.0246 12.5355 12.9987 12.667 12.9987C12.7985 12.9987 12.9287 13.0246 13.0502 13.075C13.1716 13.1253 13.282 13.199 13.375 13.292L15.667 15.586L20.959 10.292Z" fill="#5FCF86" />
        </svg>
      </div>
      <div className="content">
        <h6>Bảo hiểm</h6>
        <div className="desc">
          <p className="info">Chuyến đi được bảo hiểm bởi MIC</p><a className="read-more">Đọc thêm</a>
        </div>
      </div>
    </div>


  
    
    <div className="price-container">
      <h6>Bảng tính giá</h6>
      <div className="price-item"> 
        <p>Đơn giá thuê</p>
        <p className="cost">360.000đ&nbsp;/&nbsp;ngày</p>
      </div>
      <div className="price-item"> 
        <p>Đơn giá phí dịch vụ</p>
        <p className="cost">110.000đ&nbsp;/&nbsp;ngày</p>
      </div>
      <div className="price-item"> 
        <p>Phí bảo hiểm</p>
        <p className="cost">110.000đ&nbsp;/&nbsp;ngày</p>
      </div>
      <div className="line-page"> </div>
      <div className="price-item total">
        <p>Tổng giá trị</p>
        <p className="cost">580.000đ</p>
      </div>
    </div>
    <div className="desc-car"> 
      <h6>Giấy tờ thuê xe</h6>
      <div className="required-papers">
        <div className="required-papers__item"> 
          <p>Bắt buộc</p>
          <div className="item-wrap"> 
            <div className="item-wrap__item error"><img src="https://n1-cstg.mioto.vn/v4/p/m/icons/papers/cmnd.png" alt="" />
              <h6>GPLX  / CMND</h6>
              <p className="note">Gửi ảnh để xác nhận</p>
            </div>
          </div>
        </div>
        <div className="required-papers__item"> 
          <p>Chọn 1 trong 2 hình thức:</p>
          <div className="item-wrap"> 
            <div className="item-wrap__item"><img src="https://n1-cstg.mioto.vn/v4/p/m/icons/papers/cmnd.png" alt="" />
              <h6>CCCD gắn chip </h6>
              <p className="note">Dùng cho đối chiếu</p>
            </div>
          </div>
        </div>
        <div className="required-papers__item"> 
          <div className="height-text" />
          <div className="item-wrap"> 
            <div className="item-wrap__item"><img src="https://n1-cstg.mioto.vn/v4/p/m/icons/papers/cmnd.png" alt="" />
              <h6>Hộ khẩu / KT3 / Passport</h6>
              <p className="note">Chủ xe Giữ lại</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="desc-car"> 
      <h6>Tài sản thế chấp</h6>
      <pre>15 triệu ( tiền mặt / chuyển khoản cho chủ xe khi nhận xe ){"\n"}Hoặc xe máy ( kèm cà vẹt gốc ) giá trị 15 triệu</pre>
    </div>
    <div className="desc-car"> 
      <h6>Điều khoản </h6>
      <pre>Lorem ipsum dolor sit amet consectetur. Massa in id platea ornare facilisi ullamcorper. Velit hendrerit eget enim curabitur a facilisi enim massa ullamcorper. Amet vulputate sem eros ultrices. Gravida arcu eu vulputate cursus. Gravida diam vestibulum rhoncus duis habitasse adipiscing. Et ac amet massa sed vitae ullamcorper cursus quis.</pre>
    </div>
    <div className="desc-car"> 
      <h6>Chính sách huỷ chuyến</h6>
      <div className="cancel-policy">
        <div className="column title"> 
          <div className="column__item case"> </div>
          <div className="column__item">Bạn hủy chuyến</div>
          <div className="column__item">Chủ xe hủy chuyến</div>
        </div>
        <div className="column">
          <div className="column__item case">Đặt cọc thành công</div>
          <div className="column__item">
            <div className="wrap-svg">
              <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 2C6.74 2 2.25 6.49 2.25 12C2.25 17.51 6.74 22 12.25 22C17.76 22 22.25 17.51 22.25 12C22.25 6.49 17.76 2 12.25 2ZM15.84 10.59L12.32 14.11C12.17 14.26 11.98 14.33 11.79 14.33C11.6 14.33 11.4 14.26 11.26 14.11L9.5 12.35C9.2 12.06 9.2 11.58 9.5 11.29C9.79 11 10.27 11 10.56 11.29L11.79 12.52L14.78 9.53C15.07 9.24 15.54 9.24 15.84 9.53C16.13 9.82 16.13 10.3 15.84 10.59Z" fill="#12B76A" />
              </svg>
            </div>Hoàn tiền 100%
          </div>
          <div className="column__item"> 
            <div className="wrap-svg">
              <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 2C6.74 2 2.25 6.49 2.25 12C2.25 17.51 6.74 22 12.25 22C17.76 22 22.25 17.51 22.25 12C22.25 6.49 17.76 2 12.25 2ZM15.84 10.59L12.32 14.11C12.17 14.26 11.98 14.33 11.79 14.33C11.6 14.33 11.4 14.26 11.26 14.11L9.5 12.35C9.2 12.06 9.2 11.58 9.5 11.29C9.79 11 10.27 11 10.56 11.29L11.79 12.52L14.78 9.53C15.07 9.24 15.54 9.24 15.84 9.53C16.13 9.82 16.13 10.3 15.84 10.59Z" fill="#12B76A" />
              </svg>
            </div>Không đền cọc<span>(Đánh giá hệ thống 3*)</span>
          </div>
        </div>
        <div className="column">
          <div className="column__item case">1h sau khi đặt cọc</div>
          <div className="column__item"> 
            <div className="wrap-svg">
              <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 2C6.74 2 2.25 6.49 2.25 12C2.25 17.51 6.74 22 12.25 22C17.76 22 22.25 17.51 22.25 12C22.25 6.49 17.76 2 12.25 2ZM15.84 10.59L12.32 14.11C12.17 14.26 11.98 14.33 11.79 14.33C11.6 14.33 11.4 14.26 11.26 14.11L9.5 12.35C9.2 12.06 9.2 11.58 9.5 11.29C9.79 11 10.27 11 10.56 11.29L11.79 12.52L14.78 9.53C15.07 9.24 15.54 9.24 15.84 9.53C16.13 9.82 16.13 10.3 15.84 10.59Z" fill="#12B76A" />
              </svg>
            </div>Hoàn tiền 70%
          </div>
          <div className="column__item"> 
            <div className="wrap-svg">
              <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 2C6.74 2 2.25 6.49 2.25 12C2.25 17.51 6.74 22 12.25 22C17.76 22 22.25 17.51 22.25 12C22.25 6.49 17.76 2 12.25 2ZM15.84 10.59L12.32 14.11C12.17 14.26 11.98 14.33 11.79 14.33C11.6 14.33 11.4 14.26 11.26 14.11L9.5 12.35C9.2 12.06 9.2 11.58 9.5 11.29C9.79 11 10.27 11 10.56 11.29L11.79 12.52L14.78 9.53C15.07 9.24 15.54 9.24 15.84 9.53C16.13 9.82 16.13 10.3 15.84 10.59Z" fill="#12B76A" />
              </svg>
            </div>Đền cọc 30%<span>(Đánh giá hệ thống 3*)</span>
          </div>
        </div>
        <div className="column">
          <div className="column__item case">7 ngày trước chuyến đi</div>
          <div className="column__item"> 
            <div className="wrap-svg">
              <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 2C6.74 2 2.25 6.49 2.25 12C2.25 17.51 6.74 22 12.25 22C17.76 22 22.25 17.51 22.25 12C22.25 6.49 17.76 2 12.25 2ZM14.67 13.39C14.97 13.69 14.96 14.16 14.67 14.45C14.52 14.59 14.33 14.67 14.14 14.67C13.95 14.67 13.75 14.59 13.61 14.44L12.25 13.07L10.9 14.44C10.75 14.59 10.56 14.67 10.36 14.67C10.17 14.67 9.98 14.59 9.84 14.45C9.54 14.16 9.53999 13.69 9.82999 13.39L11.2 12L9.82999 10.61C9.53999 10.31 9.54 9.84 9.84 9.55C10.13 9.26 10.61 9.26 10.9 9.56L12.25 10.93L13.61 9.56C13.9 9.26 14.37 9.26 14.67 9.55C14.96 9.84 14.97 10.31 14.67 10.61L13.3 12L14.67 13.39Z" fill="#F04438" />
              </svg>
            </div>Không hoàn tiền
          </div>
          <div className="column__item">
            <div className="wrap-svg">
              <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 2C6.74 2 2.25 6.49 2.25 12C2.25 17.51 6.74 22 12.25 22C17.76 22 22.25 17.51 22.25 12C22.25 6.49 17.76 2 12.25 2ZM14.67 13.39C14.97 13.69 14.96 14.16 14.67 14.45C14.52 14.59 14.33 14.67 14.14 14.67C13.95 14.67 13.75 14.59 13.61 14.44L12.25 13.07L10.9 14.44C10.75 14.59 10.56 14.67 10.36 14.67C10.17 14.67 9.98 14.59 9.84 14.45C9.54 14.16 9.53999 13.69 9.82999 13.39L11.2 12L9.82999 10.61C9.53999 10.31 9.54 9.84 9.84 9.55C10.13 9.26 10.61 9.26 10.9 9.56L12.25 10.93L13.61 9.56C13.9 9.26 14.37 9.26 14.67 9.55C14.96 9.84 14.97 10.31 14.67 10.61L13.3 12L14.67 13.39Z" fill="#F04438" />
              </svg>
            </div>Đền cọc 100%<span>(Đánh giá hệ thống 2*)</span>
          </div>
        </div>
      </div>
    </div>
 
  </div> */
}
